module.exports = __webpack_public_path__ + "static/img/error@2x.538e9850.png";